<template>
    <div class="w100">
        <article class="wContent center" style="padding: 10px 0 20px 0;">

            <div class="mw-fast-list-box">
                <span class="mw-fast-list-sub" @click="changeInforTab(item, '快讯')">快讯</span>
                <span class="mw-fast-list-sub" v-for="(item, index) in inforTab_list" :key="index" @click="changeInforTab(item)">{{ item.type_name }}</span>
            </div>

            <el-row :gutter="20" style="margin-top: 20px;">
                <el-col :span="16">
                    <div class="grid-content">
                        <!-- 广告展位 start -->
                        <div class="ad" style="margin-bottom: 20px;" v-show="adIDsIndex[2] && adIDsIndex[2]['list'].length > 0">
                            <a :href="adIDsIndex[2] ? ( adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adLink'] : '') : ''" target="_blank">
                                <img :src="adIDsIndex[2] ? (adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: auto;" class="w100">
                            </a>
                        </div>
                        <!-- 广告展位 end -->
                        <div class="bgWhite p10 textRight">
                            <!-- 搜索部分 start -->
                            <div class="mw-search-box">
                                <div class="mw-search-keybox inlineBlock">
                                    <el-input placeholder="搜索" v-model="keyword" clearable @blur="newflashFindList"></el-input>
                                </div>
                                <div class="mw-search-daybox inlineBlock">
                                    <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" @change="searchFastList" :clearable="false"></el-date-picker>
                                    <span class="value">日期</span>
                                </div>
                            </div>
                            <!-- 搜索部分 end -->

                            <!-- 列表部分1 start -->
                            <div class="part-1 p10 fontLighter" style="height: 500px; overflow-y: auto;">
                                <div v-show="isHasFlashList">
                                    <div class="part-main textLeft" v-for="(item, index) in newflash_list" :key="index">
                                        <span class="part-date font18 fontNormal">{{ item.date ? (item.date + '，' +item.week) : '' }}</span>
                                        <div class="part-list bgGrey" v-for="(cItem, cIndex) in item.list" :key="cIndex">
                                            <el-row>
                                                <el-col :span="3">
                                                    <div class="grid-content part-list-time font18 textCenter">
                                                        {{ cItem.newsDate.substr(10, 6) }}
                                                    </div>
                                                </el-col>
                                                <el-col :span="21">
                                                    <div class="grid-content part-list-main fontLight">
                                                        {{ cItem.newsTxt }}
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="!isHasFlashList" class="textCenter font14">暂无快讯信息</div>
                            </div>
                            <!-- 列表部分1 end -->
                        </div>

                        <!-- 广告展位 start -->
                        <div class="ad mw-modular-box" v-show="adIDsIndex[0] && adIDsIndex[0]['list'].length > 0">
                            <a :href="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''" target="_blank">
                                <img :src="adIDsIndex[0] ? (adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 100px;" class="w100">
                            </a>
                        </div>
                        <!-- 广告展位 end -->

                        <!-- 列表部分2 start -->
                        <div class="part-2 bgWhite" style="min-height: 715px;">
                            <div class="part-tab">
                                <div class="part-tab-list">
                                    <el-tabs class="textCenter">
                                        <el-tab-pane label="资讯推荐" name="0" disabled>
                                            <div v-for="(item, index) in consult_sel_all" :key="index">
                                                <div class="part-tab-clist pointer" v-show="item.pic" @click="goDetailPage(item.primary_id)">
                                                    <span class="tag" style="padding: 0" :title="item.type_name">{{ item.type_name }}</span>
                                                    <div style="flex: 1;"> <img :src="'data:image/jpeg;base64,' + item.pic" alt="" srcset=""> </div>
                                                    <div style="flex: 4;" class="w100 textLeft main">
                                                        <h4 class="font16 fontBold fontNormal">{{ item.the_title }}</h4>
                                                        <div class="main-sub fontLight">{{ item.overview }}</div>
                                                        <div class="main-tags-box">
                                                            <span v-if="item.the_table">
                                                                <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                                                    <span class="main-tag fontRed" v-if="table" @click.stop="goSearchPage(table)">{{ table }}</span>
                                                                </span>
                                                            </span>
                                                            <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                            <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                            <span>{{ compareTime(item.create_date) }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="part-tab-clist pointer" v-show="!item.pic" style="border-bottom: 1px solid #ddd" @click="goDetailPage(item.primary_id)">
                                                    <span class="tag" style="padding: 0" :title="item.type_name">{{ item.type_name }}</span>
                                                    <div class="w100 textLeft main" style="padding-left: 10px">
                                                        <h4 class="font16 fontBold fontNormal" style="margin-left: 70px">{{ item.the_title }}</h4>
                                                        <div class="main-sub fontLight">{{ item.overview }}</div>
                                                        <div class="main-tags-box">
                                                            <span v-if="item.the_table">
                                                                <span v-for="(table, tableI) in item.the_table.split(',')" :key="tableI" style="margin-right: 5px;" class="inlineBlock">
                                                                    <span class="main-tag fontRed" v-if="table" @click.stop="goSearchPage(table)">{{ table }}</span>
                                                                </span>
                                                            </span>
                                                            <span v-if="item.the_table">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                            <span>{{ item.oper_man ? item.oper_man : '未知' }}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                            <span>{{ compareTime(item.create_date) }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>
                        </div>
                        <div class="textCenter" style="padding-top: 30px; margin-bottom: 20px;" v-show="isShowLoad">
                            <el-button class="load-more-btn" @click="tNewsConsultSelAll()">+ 加载更多</el-button>
                        </div>
                        <!-- 列表部分2 end -->

                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <div class="varieties-box bgWhite">
                            <h4>
                                <span class="font14 block">品种报告</span>
                                <span class="block textRight"><a class="fontDark pointer font14" @click="goReportPage('')">更多+</a></span>
                            </h4>
                            <div class="varieties-list">
                                <span v-for="(item, index) in reportClassify" :key="index" @click="goReportPage(item.sortId)"><a class="fontWhite pointer">{{ item.sortName }}</a></span>
                            </div>
                        </div>

                        <div class="ad mw-modular-box" v-show="adIDsIndex[3] && adIDsIndex[3]['list'].length > 0" style="margin: -10px 0 10px 0">
                            <a :href="adIDsIndex[3] ? ( adIDsIndex[3]['list'].length > 0 ? adIDsIndex[3]['list'][0]['adLink'] : '') : ''" target="_blank">
                                <img :src="adIDsIndex[3] ? (adIDsIndex[3]['list'].length > 0 ? adIDsIndex[3]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 100px;" class="w100">
                            </a>
                        </div>

                        <MapControl></MapControl>

                        <div v-if="adIDsIndex[4]['list']" style="margin-bottom: 20px; margin-top: -10px;">
                            <a v-for="(item, index) in adIDsIndex[4]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: 20px; margin-bottom: -10px;">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>

                        <PriceIndexControl class="mw-modular-box"></PriceIndexControl>

                        <HotRecord :ad="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''"></HotRecord>

                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import MapControl from '../../templates/mapControl'
import PriceIndexControl from '../../templates/priceIndexControl'
import HotRecord from '../../templates/hotRecord'
import $ from 'jquery'
import { baseUrl, navigationUrl, getThreeDays, adIDs } from '../../assets/js/common'
export default {
    name: 'Information',
    components: { MapControl, PriceIndexControl, HotRecord, ConcatsControl },
    data () {
        return {
            token_cyw: '',
            adIDsIndex: [],
            isLogin: false,
            isShowLoad: true,
            pagenum: 1,
            inforTab_list: [],
            keyword: '',
            date: '',
            newflash_list: [],
            isHasFlashList: false,
            consult_sel_all: [],
            reportClassify: [],
            weekdayArr: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            hasReport: false
        }
    },
    mounted () {
        // 初始化内容
        // this.token_cyw = this.$cookies.get('token_cyw');
        this.getAdByAdp();
        this.findNewsClassify();
        this.newflashFindList();
        this.tNewsConsultSelAll();
        this.findReportSortByUserFormat();
        this.findNaTree();
    },
    methods: {
        //页面操作
        // getUserInfo (token_cyw) {
        //     const self = this;
        //     if (token_cyw) {
        //         self.$get(`${baseUrl.sso}/user/userByToken/${token_cyw}`, {}).then(res_1 => {
        //             if (res_1.code == 200) {
        //                 self.isLogin = true;
        //             } else {}
        //         })
        //     }
        // },
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'indexLeft1',
                id: adIDs['indexLeft1'],
                list: []
            },{
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            },{
                name: 'zxleft',
                id: adIDs['zxleft'],
                list: []
            },{
                name: 'zx39',
                id: adIDs['zx39'],
                list: []
            },{
                name: 'zx55',
                id: adIDs['zx55'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },

/* ***** 获取资讯分类 start ******************************* */
        findNewsClassify () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/news_classify?pagenum=1&pernum=99`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        self.inforTab_list = [];
                        res.data.forEach((item, index) => {
                            if (item.the_level == 1 && item.is_valid == 'Y') {
                                self.inforTab_list.push(item);
                            }
                        })
                        // self.inforTab_list = res.data;
                        // self.tNewsConsultSel(res.data[0]);
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    self.$message.error('未获取到资讯分类信息')
                }
            })
        },
/* ***** 获取资讯分类 end ******************************** */

/* ***** 获取资讯内容 start ******************************** */

        // 快讯查询
        newflashFindList () {
            const self = this;
            self.newflash_list = new getThreeDays();
            self.newflash_list.forEach((item, index) => {
                self.$post(`${baseUrl.cyw}/newflash/findList/1/9999`, {date: item.date, newsTxt: self.keyword}).then(res => {
                    if (res.code == 0) {
                        if (res.data.length > 0) {
                            self.isHasFlashList = true;
                            self.newflash_list[index].list = res.data;
                        } else {
                            self.newflash_list[index] = {date: '', week: '', list: []};
                        }
                    }else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    self.$message.error('未获取到快讯信息');
                })
            })
        },

        searchFastList () {
            const self = this;
            self.newflash_list = [];
            self.$post(`${baseUrl.cyw}/newflash/findList/1/9999`, {date: self.date, newsTxt: self.keyword}).then(res => {
                if (res.code == 0) {
                    if (res.data.length > 0) {
                        let day = new Date(self.date).getDay();
                        self.newflash_list.push({date: self.date, week: self.weekdayArr[day], list: res.data})
                        self.isHasFlashList = true;
                    } else {
                        self.isHasFlashList = false;
                    }
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到快讯信息');
            })
        },

/* ***** 获取资讯内容 end ********************************** */

/* ***** 获取全部资讯内容 start **************************** */

        tNewsConsultSelAll () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_news_consult_fuzzy`,
                data: {
                    pagenum: self.pagenum,
                    pernum: 5
                },
                dataType: 'json',
                type: 'get', success: (res) => {
                    if (res.data) {
                        if (res.data.length < 5) {
                            self.isShowLoad = false;
                        } else {
                            self.pagenum++;
                        }
                        self.consult_sel_all = self.consult_sel_all.concat(res.data);
                    } else {
                        self.isShowLoad = false;
                    }
                },
                error: () => {
                    self.$message.error('未获取到资讯信息')
                }
            })
        },

/* ***** 获取全部资讯内容 end ****************************** */

/* ***** 获取报告分类 - 唐宋100指数报告-分品种 下的分类 start ****************************** */

        // 获取权限
        findNaTree () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            let url = ``;
            if (token_cyw) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=Y`;
                    } else {
                        url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
                    }
                    self.$get(url, {}).then(res => {
                        if (res.code == 0) {
                            res.data.forEach((item, index) => {
                                if (item.navigationName == '研报') {
                                    self.hasReport = true;
                                }
                            })
                        } else {
                            self.hasReport = false;
                        }
                    }).catch(err => {})
                })
            } else {
                url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
                self.$get(url, {}).then(res => {
                    if (res.code == 0) {
                        self.submenu_list_1 = [];
                        res.data.forEach((item, index) => {
                            if (item.navigationName == '研报') {
                                self.hasReport = true;
                            }
                        })
                    } else {
                        self.hasReport = false;
                    }
                }).catch(err => {
                })
            }
        },

        findReportSortByUserFormat () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if(res.code == 0) {
                    res.data.forEach((item, index) => {
                        if (item.childs.length > 0) {
                            self.reportClassify = item.childs;
                        }
                    })
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到报告分类信息');
            })
        },

/* ***** 获取报告分类 - 唐宋100指数报告-分品种 下的分类 end ******************************** */

        /* tab切换 */
        changeInforTab (item, type) {
            if (type) {
                this.$router.push(`/home/inforFastList`)
            } else {
                this.$router.push(`/home/inforList/${item.type_name}`)
            }
        },

        goReportPage (id) {
            const self = this;
            if (self.hasReport) {
                this.$router.push(`${navigationUrl['研报']}?sortId=${id}`)
            } else {
                this.$message({
                    message: '登录即可查看全部研报信息',
                    type: 'warning'
                })
            }
        },

        goDetailPage (id) {
            // this.$router.push(`/home/inforDetail/${id}`)
            let routeUrl = this.$router.resolve({
                path: `/home/inforDetail/${id}`
                // query: {id:96}
            });
            window.open(routeUrl.href, '_blank');
        },
        goSearchPage (name) {
            // this.$router.push(`/home/searchPage?key=${name}&type=1`);
            let routeUrl = this.$router.resolve({
                path: `/home/searchPage?key=${name}&type=1`
                // query: {id:96}
            });
            window.open(routeUrl.href, '_blank');
        },

        // 判断时间
        compareTime (date) {
            const time = new Date().getTime();
            const time_1 = new Date(date).getTime();
            const range = time - time_1;
            let time_2;
            let type = 'time';
            if (range <= 1800000) {
                time_2 = Math.floor(range / 60 / 1000);
                // time_2 += '分钟前'
                time_2 = time_2 < 0 ? '刚刚' : time_2 + '分钟前'
            } else if (range < 21600000 && range > 1800000) {
                if (range >= 3600000) {
                    time_2 = Math.floor(range / 60 / 60 / 1000);
                    time_2 += '小时前'
                } else {
                    time_2 = Math.floor(range / 60 / 1000);
                    time_2 += '分钟前'
                }
            } else if (range > 21600000) {
                const newDate = new Date(date);
                time_2 = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
                type = 'date'
            }
            return time_2
        },
    },
}
</script>

<style scoped>
    @import url('information.css');
</style>